module.exports = __webpack_public_path__ + "static/media/3310.672adda0.jpg";